import React, { useState } from "react";

const DeudasDetalleTable = ({ deudas = [], filtros = {} }) => {
  const [mostrarTodos, setMostrarTodos] = useState(false);
  const limite = 10;
  const deudasMostradas = mostrarTodos ? deudas : deudas.slice(0, limite);

  return (
    <div
      className="card shadow-sm mb-4"
      style={{ borderRadius: "0.75rem", maxWidth: "900px" }}
    >
      <div className="card-header bg-white border-0 d-flex justify-content-between align-items-center">
        <h6 className="fw-bold text-primary mb-0">Deudas Detalle</h6>
      </div>
      <div className="card-body p-2">
        <div className="table-responsive">
          <table className="table table-sm table-hover table-bordered align-middle text-nowrap mb-0">
            <thead className="table-light">
              <tr>
                <th>Cliente</th>
                <th>Cita</th>
                <th>Monto Pagado</th>
                <th>Deuda Pendiente</th>
                <th>Estado Pago</th>
              </tr>
            </thead>
            <tbody>
              {deudasMostradas.length === 0 ? (
                <tr>
                  <td colSpan="5" className="text-center text-muted">
                    No hay registros de deudas
                  </td>
                </tr>
              ) : (
                deudasMostradas.map((d) => {
                  const montoPagado = d.estado_pago === "pago" ? d.monto : 0;
                  const deudaPendiente =
                    d.estado_pago === "debe" || d.estado_pago === "fiao"
                      ? d.monto
                      : 0;

                  return (
                    <tr key={d.pago_id}>
                      <td>{d.cliente}</td>
                      <td>{`${new Date(
                        d.fecha_cita
                      ).toLocaleDateString()} ${d.hora_cita}`}</td>
                      <td>${montoPagado.toFixed(2)}</td>
                      <td>${deudaPendiente.toFixed(2)}</td>
                      <td>
                        <span
                          className={`badge rounded-pill px-2 ${
                            d.estado_pago === "debe"
                              ? "bg-danger"
                              : d.estado_pago === "fiao"
                              ? "bg-warning text-dark"
                              : "bg-success"
                          }`}
                        >
                          {d.estado_pago}
                        </span>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>

        {deudas.length > limite && (
          <div className="text-center mt-3">
            <button
              className="btn btn-sm btn-outline-primary"
              onClick={() => setMostrarTodos(!mostrarTodos)}
            >
              {mostrarTodos ? "Ver menos" : `Ver más (${deudas.length})`}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default DeudasDetalleTable;